import { Box, TextField, Button, Select, MenuItem, Table, TableBody, TableRow, TableCell, TableContainer, TableHead, FormControl, Stack, Pagination, FormControlLabel, Checkbox } from '@mui/material'
import React, { useEffect, useState } from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useLocation, useNavigate } from 'react-router-dom';
import ModalHistoryProjectParticipation from 'components/modal/healthPromotion/ModalHistoryProjectParticipation';
import ModalRemoveAllNames from 'components/modal/healthPromotion/ModalRemoveAllNames';
import ModalSaveProject from 'components/modal/healthPromotion/ModalSaveProject';
import * as api from '../services/api'
import Loader from 'components/Loader';

function SelectedLists() {
    const location = useLocation()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [search, setSearch] = useState('')

    const [department, setDepartment] = useState('')
    const [optionDepartment, setOptionDepartment] = useState([])

    const [numPage, setNumPage] = useState(10)
    const [page, setPage] = useState(1)
    const [maxPage, setMaxPage] = useState(1)
    const [showList, setShowList] = useState([])

    const [listProject, setListProject] = useState([])
    const [listProjectAll, setListProjectAll] = useState([])

    const [selected, setSelected] = useState([]); //pid
    const [selectedData, setSelectedData] = useState([]); //item
    const [selectAll, setSelectAll] = useState(false);

    const [projectCode, setProjectCode] = useState(null)
    const [projectName, setProjectName] = useState(null)
    const [year, setYear] = useState(null)

    const [headerKey, setHeaderKey] = useState([])

    const [itemHistory, setItemHistory] = useState([])
    const [openModalHistory, setOpenModalHistory] = useState(false)
    const [openModalDelete, setOpenModalDelete] = useState(false)
    const [openModalSave, setOpenModalSave] = useState(false)

    useEffect(() => {
        findDepartment()
    }, [])

    useEffect(() => {
        let state = location.state
        setListProject(state['list'])
        setListProjectAll(state['list'])
        setSelectedData(state['list'])
        setSelected(state['pid'])

        setShowList(state['list'])
        setMaxPage((Math.ceil(state['list'].length / 10)))

        const filteredKey = getValueAndResultKeys(state['list']);
        setHeaderKey(filteredKey)

        setProjectCode(state['code'])
        setProjectName(state['name'])
        setYear(state['year'])
    }, [])

    useEffect(() => {
        handleClickSearch()
    }, [department])

    useEffect(() => {
        let start = page * 10 - 10
        setShowList(listProject.slice(start, start + 10))
    }, [page, listProject])

    // useEffect(() => {
    //     console.log(selected);
    // }, [selected]);
    useEffect(() => {
        console.log(selectedData);
    }, [selectedData]);

    const handlePageChange = (event, page) => {
        setPage(page)
    }

    const findDepartment = async () => {
        setLoading(true)
        let res = await api.findDepartmentFixToken()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                let data = res['data']['data']

                let option = []
                data.forEach((item) => {
                    const code = item?.department_code;
                    const name = item?.department_name;
                    if (code && name) {
                        option.push({ key: code, value: name });
                    }
                });

                const unique = [...new Map(option.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
                setOptionDepartment(unique)
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const getValueAndResultKeys = (dataArray) => {
        const keySet = new Set();
        dataArray.forEach(obj => {
            Object.keys(obj).forEach(key => {
                if (key.includes('value_') || key.includes('result_')) {
                    keySet.add(key);
                }
            });
        });
        return Array.from(keySet);
    };

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            let newSelected = [...selected];
            const selectedList = showList.filter(item => !newSelected.includes(item.pid));
            newSelected = newSelected.concat(selectedList.map(item => item.pid));

            let newSelectedData = [...selectedData, ...selectedList];

            setSelectedData(newSelectedData);
            setSelected(newSelected);
            // setSelectAll(true);
        } else {
            let newSelected = [...selected];
            const newShowList = showList.map(item => item.pid);
            newSelected = newSelected.filter(pid => !newShowList.includes(pid));

            let newSelectedData = [...selectedData];
            newSelectedData = newSelectedData.filter(item => newSelected.includes(item.pid));

            setSelectedData(newSelectedData);
            setSelected(newSelected);
            // setSelectAll(false);
        }
    };
    const handleChange = (event, i) => {
        if (selected.includes(i.pid)) {
            setSelected(selected.filter(item => item !== i.pid));
            setSelectedData([...selectedData].filter(item => item.pid !== i.pid));
        } else {
            setSelected([...selected, i.pid]);
            let newSelectedData = [...selectedData, i];
            setSelectedData(newSelectedData);
        }
    };

    const handleClickSearch = () => {
        if (department === 'null') {
            if (search === '') {
                setShowList(listProjectAll)
                setPage(1)
                setMaxPage((Math.ceil(listProjectAll.length / 10)))
            } else {
                const filteredItems = listProjectAll.filter((item) =>
                    item.full_name.toLowerCase().includes(search.toLowerCase())
                )
                setShowList(filteredItems)
                setPage(1)
                setMaxPage((Math.ceil(filteredItems.length / 10)))
            }
        } else {
            if (search === '') {
                const filteredItems = listProjectAll.filter((item) =>
                    item.department_code.toLowerCase().includes(department.toLowerCase())
                )
                setShowList(filteredItems)
                setPage(1)
                setMaxPage((Math.ceil(filteredItems.length / 10)))
            } else {
                const filteredItems = listProjectAll.filter((item) =>
                    item.full_name.toLowerCase().includes(search.toLowerCase()) && item.department_code.toLowerCase().includes(department.toLowerCase())
                )
                setShowList(filteredItems)
                setPage(1)
                setMaxPage((Math.ceil(filteredItems.length / 10)))
            }
        }
    }

    const handleClickOpenHistory = (item) => {
        setItemHistory(item)
        setOpenModalHistory(true)
    }
    const handleClickOpenDelete = () => {
        setOpenModalDelete(true)
    }
    const handleClickOpenSave = () => {
        setOpenModalSave(true)
    }

    const saveProject = () => {
        let body = {
            "year": year,
            "project_code": projectCode,
            "member_list": selected
        }
        console.log(body)
        addMember(body)
    }

    const addMember = async (body) => {
        setLoading(true)
        let res = await api.member(body)
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                //alert(res['data']['message'])
                navigate('/managePromote')
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            {openModalHistory ?
                <ModalHistoryProjectParticipation
                    data={itemHistory}
                    onClose={() => { setOpenModalHistory(false) }}
                />
                : null
            }
            {openModalDelete ?
                <ModalRemoveAllNames
                    onClose={() => { setOpenModalDelete(false) }}
                    onSubmit={() => {
                        console.log('นำออกทั้งหมด')
                        setSelectedData([]);
                        setSelected([]);
                    }}
                />
                : null
            }
            {openModalSave ?
                <ModalSaveProject
                    onClose={() => { setOpenModalSave(false) }}
                    data={selected}
                    name={projectName}
                    onSubmit={() => {
                        console.log('บันทึก')
                        saveProject()
                    }}
                />
                : null
            }

            <Loader loading={loading} />
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gridGap: '10px'
                }}>
                    <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                    <Box sx={{
                        cursor: 'pointer'
                    }}
                        onClick={() => {
                            navigate('/participantScreening', { state: { name: location.state.name, code: location.state.code, year: location.state.year } })
                        }}
                    >กลับไป คัดกรองรายชื่อเข้าร่วมโครงการ</Box>
                </Box>

                <Box sx={{
                    fontWeight: 600,
                    color: "#478F96",
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}>รายชื่อที่เลือกไว้</Box>

                <Box sx={{
                    border: '1px solid #478F96',
                    borderRadius: '10px',
                    padding: '20px',
                    display: 'grid',
                    gridGap: '10px'
                }}>
                    <Box sx={{
                        fontWeight: 600,
                        "@media (max-width: 800px)": {
                            textAlign: "center",
                        },
                    }}>ค้นหาด้วยชื่อ</Box>
                    <Box sx={{
                        border: '1px solid #478F96',
                        borderRadius: '10px',
                        display: 'flex',
                        padding: '5px'
                    }}>
                        <TextField
                            fullWidth
                            variant="standard"
                            sx={{
                                ...InputCSS
                            }}
                            InputProps={{
                                disableUnderline: true,
                            }}
                            placeholder="พิมพ์ข้อความเพื่อค้นหาข้อมูล..."
                            value={search}
                            onChange={(e) => { setSearch(e.target.value) }}
                        />
                        <Button variant='contained' onClick={() => { handleClickSearch() }}>ค้นหา</Button>
                    </Box>

                    <Box>
                        <Box sx={{ fontWeight: 500 }}>เลือกสังกัด</Box>
                        <Select
                            size="small"
                            sx={{ ...SelectCss }}
                            value={department || 'null'}
                            onChange={(e) => { setDepartment(e.target.value) }}
                        >
                            <MenuItem value="null">ทั้งหมด</MenuItem>
                            {optionDepartment.map((i, idx) => (
                                <MenuItem key={idx} value={i['key']}>{i['value']}</MenuItem>
                            ))}
                        </Select>
                    </Box>

                    <Box sx={{
                        overflow: 'auto'
                    }} >
                        <TableContainer sx={{ maxHeight: '700px' }} >
                            <Table sx={{ minWidth: '1500px' }}>
                                <TableHead sx={{ backgroundColor: '#C8EBEB' }}>
                                    <TableRow>
                                        <TableCell>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={selectedData.length === listProjectAll.length}
                                                        onChange={handleSelectAll}
                                                    />
                                                }
                                                label="ทั้งหมด"
                                            />
                                        </TableCell>
                                        <TableCell>ปี</TableCell>
                                        <TableCell>ยศ</TableCell>
                                        <TableCell>ชื่อ-นามสกุล</TableCell>
                                        <TableCell width={'150px'}>เลขบัตรประชาชน</TableCell>
                                        <TableCell>อายุ</TableCell>
                                        <TableCell>สังกัด</TableCell>
                                        <TableCell width={'120px'} >ประวัติการ เข้าร่วมโครงการ</TableCell>
                                        {headerKey.map((key, idx) => (
                                            <TableCell key={idx}>{key}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {showList.length > 0 ? (
                                        showList.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>
                                                    <FormControlLabel
                                                        key={item}
                                                        control={
                                                            <Checkbox
                                                                value={item}
                                                                checked={selected.includes(item.pid)}
                                                                onChange={(e) => { handleChange(e, item) }}
                                                            />
                                                        }
                                                    />
                                                </TableCell>
                                                <TableCell>{item['year_1']}</TableCell>
                                                <TableCell>{item['pname']}</TableCell>
                                                <TableCell>{item['fname'] + ' ' + item['lname']}</TableCell>
                                                <TableCell>{item['pid']}</TableCell>
                                                <TableCell>{item['age']}</TableCell>
                                                <TableCell>{item['department_name_short']}</TableCell>
                                                <TableCell align='center'>{item['join_project_history'] == true ?
                                                    <Box sx={{
                                                        textDecoration: 'underline',
                                                        cursor: 'pointer'
                                                    }}
                                                        onClick={() => { handleClickOpenHistory(item['join_project_details']) }}
                                                    >มีประวัติ</Box>
                                                    : '-'}
                                                </TableCell>

                                                {headerKey.map((key, idx) => (
                                                    <TableCell key={idx}>{item[key] && item[key].trim() !== '' ? item[key] : '-'}</TableCell>
                                                ))}

                                            </TableRow>
                                        ))
                                    )
                                        :
                                        (
                                            <TableRow>
                                                <TableCell colSpan='8'>
                                                    <Box sx={{ textAlign: 'center' }}>ไม่มีข้อมูล</Box>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }

                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'end',
                        margin: 2
                    }}>
                        {/* <Box sx={{ width: '100px' }}>
                            <FormControl fullWidth>
                                <Select
                                    value={numPage}
                                    onChange={(e) => {
                                        const {
                                            target: { value },
                                        } = e;
                                        setNumPage(value)
                                    }}
                                    size='small'
                                    sx={{ width: '100px', fontSize: '14px' }}
                                >
                                    <MenuItem value={5}>5</MenuItem>
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={20}>20</MenuItem>
                                </Select>
                            </FormControl>
                        </Box> */}
                        <Stack spacing={2}>
                            <Pagination
                                count={maxPage}
                                page={page}
                                onChange={handlePageChange}
                                shape="rounded"
                                color="primary"
                            />
                        </Stack>
                    </Box>

                    <Box>
                        <Button
                            variant='contained'
                            sx={{ backgroundColor: '#E06262' }}
                            onClick={() => { handleClickOpenDelete() }}
                        >นำออกทั้งหมด</Button>
                    </Box>
                </Box>

                <Box sx={{ textAlign: 'end' }}>
                    <Button
                        variant='contained'
                        onClick={() => { handleClickOpenSave() }}
                    >บันทึก</Button>
                </Box>

            </Box>
        </>
    )
}

export default SelectedLists

const InputCSS = {
    padding: '5px',
    border: 'none',
    '&.MuiInputBase-root': {
        border: 'none'
    },
    '&.MuiInputBase-root:focus': {

    }
}

const SelectCss = {
    backgroundColor: '#C8EBEB',
    border: 'none',
    '.MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
}
